import { render, staticRenderFns } from "./ExportIcon.vue?vue&type=template&id=a0f3af8c&"
import script from "./ExportIcon.vue?vue&type=script&lang=js&"
export * from "./ExportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports